import script from "./WorkflowDetailsDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowDetailsDescription.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowDetailsDescription.vue?vue&type=style&index=0&id=031d5039&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031d5039"]])

export default __exports__